
import axios from 'axios';
import { API_URL } from '../config';

const TOKEN_KEY = 'token_admin_silverjarz';
const ROLE_KEY = 'role';

export const authService = {

  getToken(): string | null {
    return localStorage.getItem(TOKEN_KEY);
  },


  getRole(): string | null {
    return localStorage.getItem(ROLE_KEY);
  },


  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) return false;
    
    return !this.isTokenExpired(token);
  },

  isTokenExpired(token: string): boolean {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp * 1000; // Convertir en millisecondes
      return Date.now() >= exp;
    } catch (error) {
      return true;
    }
  },


  getTokenExpiryTime(token: string): number {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const exp = payload.exp * 1000;
      return Math.floor((exp - Date.now()) / 1000);
    } catch (error) {
      return 0;
    }
  },


  logout(): void {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ROLE_KEY);
    window.location.href = '/login-admin';
  },

  // Sauvegarder le token
  setToken(token: string, role: string): void {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ROLE_KEY, role);
  },


  async refreshToken(): Promise<string | null> {
    try {
      const token = this.getToken();
      if (!token) return null;

      const response = await axios.post(`${API_URL}/refresh-token`, {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.data.access_token) {
        localStorage.setItem(TOKEN_KEY, response.data.access_token);
        return response.data.access_token;
      }
      return null;
    } catch (error) {
      this.logout();
      return null;
    }
  }
};